<template>
  <v-navigation-drawer
    id="sidebar"
    dark
    :mini-variant="mini"
    v-model="drawer"
    app
    :mobile-break-point="mobileBreakPoint"
  >
    <ModalSetLanguage
      :show="showModal"
      @change:modal="onChangeModal"
      @esc:modal="onChangeModal"
      hide-overlay
      max-width="350"
    />
    <CheckoutOperatorCountDown v-if="startJob && order && !isPhoneCall" />
    <ModalSetTrainingTopic
        :show="showTrainingTopicModal"
        @esc:modal="onCancelTrainingTopicModal"
        @cancel="onCancelTrainingTopicModal"
        @confirm="onTrainingTopicModalConfirm"
        max-width="350"
    />

    <v-toolbar flat class="transparent">
      <v-list expand class="sidebar-header">
        <v-list-tile avatar @click="onClickNavIcon">
          <logo v-if="mini" mini />
          <v-list-tile-content>
            <v-list-tile-title v-if="!mini">
              <logo />
            </v-list-tile-title>
          </v-list-tile-content>
          <v-spacer></v-spacer>
          <v-list-tile-action v-if="!$vuetify.breakpoint.xsOnly">
            <v-btn class="sibebar-arrow-icon" icon @click.stop="onClickNavIcon">
              <img src="@/assets/svg/arrow-sidebar.svg" alt="collapse" />
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <div class="sidebar-nav-icon">
              <ApiSocket></ApiSocket>

            </div>
          </v-list-tile-avatar>

        </v-list-tile>

        <!-- Nav -->
        <div v-for="(item, k) in nav" :key="k">
          <v-list-tile
            :to="{ name: item.routeName }"
            v-if="item.employeeStatus"
            @click="item.onClick"
            :disabled="item.disabled"
            :tabindex="-1"
          >
            <v-list-tile-avatar>
              <div class="sidebar-nav-icon" :class="[`icon-${item.routeName}`]">
                <component
                  :is="`icon-${item.icon}`"
                  :color="item.active ? $vuetify.theme.primary : '#fff'"
                ></component>
                <!-- <img class="no-avatar" :src="require(`@/assets/svg/${item.img}`)" :alt="item.svg" /> -->
              </div>
            </v-list-tile-avatar>
            <v-list-tile-content v-if="!mini">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>

        <!-- User -->
        <v-list-group
          v-model="activeUserTile"
          @click="onClickUserAvatar"
          class="user-block"
        >
          <template>
            <v-list-tile slot="activator" class="sidebar-user-wrap">
              <v-list-tile-avatar>
                <avatar :class="{ 'avatar--active': startJob }" />
              </v-list-tile-avatar>
              <v-list-tile class="sidebar_user-tile">
                <v-list-tile-title class="sidebar_user_title" v-if="!mini">
                  {{ username }}
                  <div class="sidebar_user-subtitle">{{ userRole }}</div>
                </v-list-tile-title>
              </v-list-tile>
            </v-list-tile>
          </template>
          <template v-if="!isEmployeeOperator">
            <v-list-tile v-on:click="() => false" class="user-menu">
              <v-list-tile-content>
                <v-list-tile-title>{{ lang.settings }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="user-menu" @click="logout">
              <v-list-tile-content>
                <v-list-tile-title>{{ lang.logout }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <template v-else>
            <v-list-tile
              v-for="(nav, k) in operatorNav"
              class="user-menu"
              :key="k"
              @click="nav.onClick"
              :to="{ name: nav.routeName }"
              :exact="nav.exact"
              :disabled="nav.disabled"
              :tabindex="-1"
            >
              <v-list-tile-content v-if="nav.active">
                <v-list-tile-title>{{ nav.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content class="timers">
                <Timer
                  ref="job-timer"
                  class="job-timer"
                  :start="startTimer"
                  :startValues="timer.startValues"
                  :time="timer.time"
                  show-time
                  @checkout-end="onTimerCheckoutEnd"
                  @seconds-updated="setTimeData"
                  >{{ lang.inOnline }}</Timer
                >
                <Timer
                  ref="order-timer"
                  class="job-timer"
                  :start="startOrderTimer"
                  :startValues="orderTimer.startValues"
                  :time="orderTimer.time"
                  show-time
                  >{{ lang.orderProcessingTime }}</Timer
                >
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="user-menu-footer" v-if="!startTraining">
              <v-list-tile-content>
                <AppButton
                  :text="startJob ? lang.finishWork : lang.startWork"
                  block
                  class="begin-job-btn"
                  :class="{
                    'begin-job-btn--end': startJob,
                    'begin-job-btn--start': !startJob,
                  }"
                  :handleClick="onChangeStartJob"
                  color="success"
                  :disabled="disabledStartWork"
                ></AppButton>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="!startJob" :class="{'user-menu-footer': startTraining}">
              <v-list-tile-content>
                <AppButton
                    :text="startTraining ? lang.finishTraining : lang.startTraining"
                    block
                    class="begin-training-btn"
                    :class="{
                    'begin-training-btn--end': startTraining,
                    'begin-training-btn--start': !startTraining,
                  }"
                    :handleClick="onShowTrainingTopicsModal"
                    color="info"
                    :disabled="disabledStartTraining"
                ></AppButton>
              </v-list-tile-content>
            </v-list-tile>
            <br />
            <v-list-tile class="to-not-ready-block" v-if="!startTraining && startJob">
              <v-checkbox
                :label="lang.finishWorkAfterOrder"
                v-model="notReadyCheckbox"
                color="primary"
              ></v-checkbox>
            </v-list-tile>
            <v-list-tile class="to-training-block" v-if="!startTraining && startJob">
              <v-checkbox
                  :label="lang.switchToTrainingCheckbox"
                  v-model="switchToTrainingCheckbox"
                  color="primary"
              ></v-checkbox>
            </v-list-tile>
          </template>
        </v-list-group>
        <template v-if="isEmployeeOperator">
          <v-list-tile v-if="mini && !startTraining">
            <Switcher
              color="success"
              :value="startJob"
              @change="onChangeStartJob"
              class="start-job-switcher"
              :disabled="disabledStartWork"
              :tabindex="-1"
            ></Switcher>
          </v-list-tile>
          <v-list-tile v-if="mini && startTraining">
            <Switcher
                :value="startTraining"
                @change="onShowTrainingTopicsModal"
                class="finish-training-switcher"
                color="info"
                :tabindex="-1"
                :disabled="disabledStartTraining"
            ></Switcher>
          </v-list-tile>
        </template>

        <!-- Phone Icon -->
        <template v-if="isEmployeeOperator && isOrderPage && !startTraining">
          <template v-if="showPhoneIcon">
            <v-list-tile class="operator-phone-icon">
              <v-btn
                class="sidebar-phone-icon"
                icon
                v-bind:class="{ opened: phoneActive }"
                @mouseover="onMouseOverPhone"
                @click="onPhoneClick"
              >
                <img src="@/assets/svg/phone-icon.svg" alt="collapse" />
              </v-btn>
            </v-list-tile>
          </template>
        </template>

        <!-- Footer -->
        <div class="sidebar-footer">
          <v-list-tile class="logout" :disabled="this.startJob">
            <v-list-tile-avatar @click="logout" >
              <IconLogout class="logout__icon" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
<!--          <v-list-tile class="help">-->
<!--            <v-list-tile-avatar>-->
<!--              <IconHelp class="help__icon" />-->
<!--            </v-list-tile-avatar>-->
<!--            <v-list-tile-content>-->
<!--              <v-list-tile-title></v-list-tile-title>-->
<!--            </v-list-tile-content>-->
<!--          </v-list-tile>-->
          <v-list-tile>
            <v-list-tile-avatar>
              <div @click="onShowLanguagesModal">
                <icon-lang />
              </div>
            </v-list-tile-avatar>
          </v-list-tile>
        </div>
      </v-list>
    </v-toolbar>
  </v-navigation-drawer>
</template>

<script>
import Vue from "vue";
import api from "@/api/employee";
import apiAuth from "@/api/auth";

import { mapGetters, mapActions, mapMutations, mapState } from "vuex";

import ModalSetLanguage from "@/components/ModalSetLanguage";
import Switcher from "@/components/Switcher";
import Timer from "@/components/Timer";
import AppButton from "@/components/Button";
import ApiSocket from "@/components/ApiSocket.vue";
import IconLogout from "@/components/IconLogout";
import IconHelp from "@/components/IconHelp";
import Avatar from "@/components/Avatar";
import IconLang from "@/components/IconLang";
import IconOrder from "@/components/IconOrder";
import IconEducation from "@/components/IconEducation";
import IconPerfomance from "@/components/IconPerfomance";
import IconCalculator from "@/components/IconCalculator";
import IconRefresh from "@/components/IconRefresh";
import Logo from "@/components/Logo";
import CheckoutOperatorCountDown from "@/components/CheckoutOperatorCountDown";
import ModalSetTrainingTopic from "@/components/ModalSetTrainingTopic";
import displayErrors from "@/mixins/displayErrors";
import { checkUserMedia } from "@/utils/checkUserMedia.js";

import { EventBus } from "@/eventBus";
import {
  STORAGE_ORDER_SCRIPS,
  STORAGE_ORDER_FORM,
  OPEN_AT_ORDER,
  OPEN_AT_ORDER_LOCAL
} from "@/constants/order";
import { EMPLOYEE_STATE_INACTIVE, EMPLOYEE_STATE_READY, EMPLOYEE_STATE_TRAINING } from "@/constants/employee";

import mixinDisplayInfo from "@/mixins/displayInfo";

const initTimer = {
  time: "00:00:00",
  startValues: {
    seconds: 0,
  },
};

export default {
  mixins: [mixinDisplayInfo, displayErrors],
  components: {
    Avatar,
    ApiSocket,
    Logo,
    IconLang,
    ModalSetLanguage,
    Switcher,
    Timer,
    AppButton,
    IconLogout,
    IconHelp,
    IconOrder,
    IconEducation,
    CheckoutOperatorCountDown,
    IconPerfomance,
    IconRefresh,
    IconCalculator,
    ModalSetTrainingTopic
  },
  data() {
    return {
      mini: true,
      isActive: false,
      activeUserTile: false,
      showModal: false,
      showOperatorCheckoutModal: false,
      currentLocale: null,
      startJob: false,
      timer: {
        ...initTimer,
      },
      orderInterval: null,
      initTime: false,
      phoneInput: "",
      resultValue: "",
      startTimer: false,
      notReadyCheckbox: false,
      startOrderTimer: false,
      orderTimer: {
        ...initTimer,
      },
      phoneActive: false,
      mobileBreakPoint: "1024",
      showPhone: true,
      isTimeSet: false,
      disabledStartWork: false,
      disabledStartTraining: false,
      isRefreshOrderProgress: false,
      startTraining: false,
      showTrainingTopicModal: false,
      switchToTrainingCheckbox: false,
      trainingTimeInterval: null,
      phoneIsRegistered: false
    };
  },
  computed: {
    ...mapState({
      locales: (state) => state.locales.locales,
      time: (state) => state.auth.time,
      order: (state) => state.order.order,
      refetchOrder: (state) => state.order.refetchOrder,
      isLoading: (state) => state.order.isLoadingOrder,
      isPhoneCall: (state) => state.common.isPhoneCall,
      changeReadyState: (state) => state.auth.changeReady,
    }),
    ...mapGetters({
      status: "getEmployeeStatus",
      employee: "getEmployee",
      userAttributes: "getUserAttributes",
      isEmployeeOperator: "isEmployeeOperator",
      isEmployeeEducationAllowed: "isEmployeeEducationAllowed",
    }),
    drawer: {
      get() {
        return this.$store.getters.getDrawer;
      },
      set(value) {
        this.$store.dispatch("setDrawerData", value);
      },
    },
    userRole() {
      return this.isEmployeeOperator
        ? this.userAttributes.ip
        : this.$t(window.Vocabulary.candidate);
    },
    nav() {
      return [
        {
          title: "",
          icon: "refresh",
          routeName: null,
          employeeStatus:
            this.isEmployeeOperator &&
            this.userAttributes.mode_auto &&
            this.startJob &&
            !this.order,
          active: false,
          onClick: () => {
            this.onRefreshOrderClick();
          },
        },
        {
          title: this.$t(window.Vocabulary.order),
          icon: "order",
          routeName: this.startJob ? "order.edit" : "order",
          employeeStatus: this.isEmployeeOperator,
          active: this.$route.name === "order" || this.$route.name === "order.edit",
          onClick: () => {},
        },
        {
          title: this.$t(window.Vocabulary.calculator),
          icon: "calculator",
          routeName: "calculator",
          employeeStatus: this.isEmployeeOperator ,
          active: this.$route.name === "calculator",
          disabled: this.startJob,
          onClick: () => {},
        },
        {
          title: this.$t(window.Vocabulary.rating),
          icon: "perfomance",
          routeName: "rating",
          employeeStatus: this.isEmployeeOperator,
          active: this.$route.name === "rating",
          disabled: this.startJob,
          onClick: () => {},
        },
        {
          title: this.$t(window.Vocabulary.education),
          icon: "education",
          routeName: "education",
          employeeStatus: this.isEmployeeEducationAllowed,
          active: this.$route.name && this.$route.name.includes("education"),
          disabled: this.startJob,
          onClick: () => {},
        },
      ];
    },
    operatorNav() {
      return [
        // {
        //   title: this.$t(window.Vocabulary.rating),
        //   routeName: "rating",
        //   onClick() {},
        //   exact: true
        // }
        {
          title: this.$t(window.Vocabulary.myRecalls),
          routeName: "order.recall",
          onClick() {},
          exact: true,
          active: this.userAttributes.show_recalls,
          disabled: this.startJob,
        },
        // {
        //   title: this.$t(window.Vocabulary.tickets),
        //   routeName: "tickets",
        //   onClick() {},
        //   exact: false
        // },
        // {
        //   title: this.$t(window.Vocabulary.notifications),
        //   routeName: "notifications",
        //   onClick() {},
        //   exact: true
        // }
      ];
    },
    username() {
      if (
        this.employee &&
        this.employee.employees_name &&
        this.isEmployeeOperator
      ) {
        return `${this.employee.employees_name.charAt(0)}. ${
          this.employee.employees_surname
        }`;
      }

      return this.userAttributes.username;
    },
    lang() {
      return {
        settings: this.$t(window.Vocabulary.settings),
        logout: this.$t(window.Vocabulary.logout),
        orderProcessingTime: `${this.$t(
          window.Vocabulary.orderProcessingTime
        )}: `,
        finishWork: this.$t(window.Vocabulary.finishWork),
        startWork: this.$t(window.Vocabulary.startWork),
        finishWorkAfterOrder: this.$t(window.Vocabulary.finishWorkAfterOrder),
        inOnline: `${this.$t(window.Vocabulary.inOnline)}: `,
        switchToTrainingCheckbox: this.$t(window.Vocabulary.switchToTrainingCheckbox),
        startTraining: this.$t(window.Vocabulary.startTraining),
        finishTraining: this.$t(window.Vocabulary.finishTraining),
        audioAccessDenied: this.$t(window.Vocabulary.audioAccessDenied),
        phoneRegisteredError: this.$t(window.Vocabulary.phoneRegisteredError)
      };
    },
    isOrderPage() {
      const { name } = this.$route;
      return name === "order" || name === "order.edit";
    },
  },
  methods: {
    ...mapMutations([
      "SET_EMPLOYEE_FORM_STEP_ACTIVE_DATA",
      "SET_SHOW_ORDER_FORM_DATA",
      "SET_IS_LOADING_ORDER_DATA",
      "SET_REFETCH_ORDER_DATA",
      "RESET_PRODUCTS_AND_SETS_FORM",
      "RESET_ORDER_ERRORS_RULES_DATA",
      "RESET_ORDER_ERRORS_DATA",
      "RESET_ORDER_DATA",
      "RESET_SCRIPTS_DATA",
      "SET_START_TIMESTAMP_DATA",
      "SET_NOT_READY",
      "SET_SIDEBAR_MINI_DATA",
      "SET_ORDER_LOADING_MESSAGE",
      "SET_CUSTOM_DISCOUNT_DATA",
      "SET_TRAINING_MODE_ON"
    ]),
    ...mapActions([
      "setIsLoadingData",
      "setEmployeeData",
      "changeReady",
      "setTrainingState",
      "fetchOrder",
      "getTime",
      "logoutUser",
      "toggleKeepAlive",
    ]),
    logout() {
      const vm = new Vue();
      this.logoutUser({ vm });
    },
    login() {
      this.$router.push("/login");
    },
    onShowLanguagesModal() {
      this.showModal = true;
    },
    onClickNavIcon() {
      this.mini = !this.mini;
      if (this.mini) {
        this.activeUserTile = false;
      }
    },
    onMouseOverPhone() {
      if (this.showPhone) {
        EventBus.$emit("show-phone", true);
        this.showPhone = false;
      }
    },
    onPhoneClick() {
      if (!this.phoneActive) return;
      this.phoneActive = false;
      this.showPhone = true;
      EventBus.$emit("show-phone", false);
    },
    onChangeModal(val) {
      this.showModal = val;
    },
    onReadyModal(val) {
      this.openReadyModal = val;
    },
    // async checkMediaPermission() {
    //   try {
    //     await navigator.mediaDevices.getUserMedia({
    //       audio: true,
    //     });
    //     return true;
    //   } catch {
    //     return false;
    //   }
    // },
    // async getMediaAccess() {
    //   const checkAccess = await this.checkMediaPermission();
    //   if (!checkAccess) {
    //     this.displayErrors([this.lang.audioAccessDenied]);
    //     EventBus.$emit("change-start-job-status-false");
    //     return false;
    //   }
    //   return true;
    // },

    async onChangeStartJob() {
      if (!this.startJob) {
        if (!this.phoneIsRegistered) {
          this.displayErrors([this.lang.phoneRegisteredError]);
          return false;
        }

        const mediaAllowed = await checkUserMedia();
        if (!mediaAllowed) {
          this.displayErrors([this.lang.audioAccessDenied]);
          return false;
        }
      }

      const newStartJobValue = !this.startJob;
      this.disabledStartWork = true;
      window.sessionStorage.setItem("state", +newStartJobValue);
      EventBus.$emit("change-ready",+newStartJobValue);
      const data = {
        target: "button",
        state: +newStartJobValue
      };

      this.startJob = newStartJobValue;
      this.changeReady(data).then(() => {

      }).catch(() => {
        this.startJob = !newStartJobValue;
        window.sessionStorage.setItem("state", +!newStartJobValue);
      }).finally(() => {
        this.disabledStartWork = false;
      });
      this.SET_ORDER_LOADING_MESSAGE("");
    },
    onTimerCheckoutEnd() {
      if (this.startJob && !this.userAttributes.mod_auto) {
        EventBus.$emit("refecth-order");
      }
    },
    onStartJobFalse() {
      this.SET_SHOW_ORDER_FORM_DATA(false);
      this.SET_IS_LOADING_ORDER_DATA(false);
      this.SET_REFETCH_ORDER_DATA(false);
      this.SET_START_TIMESTAMP_DATA(null);

      if (this.$route.fullPath === "/order/edit") {
        this.$router.push({ name: "order" });
      }

      this.startTimer = false;
      this.resetOrderTimer();
      EventBus.$emit("show-phone", false);
      EventBus.$emit("clear-phone-data");
      clearTimeout(this.idle);

      setTimeout(() => {
        window.sessionStorage.removeItem(STORAGE_ORDER_SCRIPS);
        window.localStorage.removeItem(OPEN_AT_ORDER);
        window.localStorage.removeItem(OPEN_AT_ORDER_LOCAL);
      }, 500);
    },
    onOperatorCheckoutTimeOut() {
      if (this.startTraining) {
        return;
      }
      this.showOperatorCheckoutModal = false;
      this.startJob = false;
      this.startTimer = false;
      const data = {
        target: "modal_checkout",
        state: EMPLOYEE_STATE_INACTIVE,
      };
      this.changeReady(data);
      window.sessionStorage.setItem("state", EMPLOYEE_STATE_INACTIVE);

    },
    setTimeData(time) {
      const timeArr = time.split(":").map(Number);
      this.timer = {
        ...this.timer,
        time,
        startValues: {
          hours: timeArr[0],
          minutes: timeArr[1],
          seconds: timeArr[2],
        },
      };
    },
    onClickUserAvatar() {
      this.mini = false;
      this.activeUserTile = true;
    },
    resetOrderTimer() {
      this.startOrderTimer = false;
      this.orderTimer = { ...initTimer };
      this.$refs["order-timer"].reset();
    },
    fetchEmployee() {
      api.get().then(({ data: { data }, status }) => {
        if (status === 200) {
          this.setEmployeeData(data);
          this.SET_EMPLOYEE_FORM_STEP_ACTIVE_DATA(++data.employee.step);
        }
      });
    },
    redirectToOrderIfOperatorReady() {
      const isReady = +window.sessionStorage.getItem("state");
      this.SET_IS_LOADING_ORDER_DATA(false);
      if (isReady !== null && isReady === EMPLOYEE_STATE_READY) {
        this.$router.push({ name: "order.edit" });
        this.startJob = true;
        this.SET_IS_LOADING_ORDER_DATA(true);
        this.toggleKeepAlive();
      }
    },
    onRefreshOrderClick() {
      if (this.isRefreshOrderProgress) return;

      this.isRefreshOrderProgress = true;

      this.fetchOrder().finally(() => {
        this.isRefreshOrderProgress = false;
      });
    },
    onShowTrainingTopicsModal() {
      if (this.startTraining) {
        this.changeTrainingJobStatus();
      } else {
        this.showTrainingTopicModal = true;
      }
    },
    onCancelTrainingTopicModal() {
      this.showTrainingTopicModal = false;
    },
    onTrainingTopicModalConfirm(params) {
      let topic = params.trainingTopic;
      this.showTrainingTopicModal = false;
      this.changeTrainingJobStatus(topic);
    },
    changeTrainingJobStatus(topic) {
      const startTraining = !this.startTraining;
      let trainingId = window.sessionStorage.getItem("trainingId") || null;
      this.disabledStartTraining = true;
      const data = {
        target: "button",
        topic: topic || null,
        trainingId: trainingId,
        state: startTraining ? EMPLOYEE_STATE_TRAINING : EMPLOYEE_STATE_INACTIVE,
      };

      this.changeReady(data).then(() => {
        this.startTraining = startTraining;
        if (!startTraining && !topic) {
          topic = window.sessionStorage.getItem("training_topic");
          window.sessionStorage.setItem("training_topic", null);
          window.sessionStorage.setItem("trainingId", null);
          window.sessionStorage.setItem("state", EMPLOYEE_STATE_INACTIVE);
        } else {
          window.sessionStorage.setItem("training_topic", topic || null);
          window.sessionStorage.setItem("state", EMPLOYEE_STATE_TRAINING);
        }
        if (startTraining && this.$route.path !== '/rating') {
          this.$router.push({ name: "rating" });
        }
      }).catch(() => {

      }).finally(() => {
        this.disabledStartTraining = false;
      });
    },
    checkOperatorStatus() {
      const operatorState = +window.sessionStorage.getItem("state");
      if (operatorState !== null && operatorState === EMPLOYEE_STATE_TRAINING) {
        this.SET_IS_LOADING_ORDER_DATA(false);
        this.startTraining = true;
        this.toggleKeepAlive();
      }
      else if (operatorState !== null && operatorState === EMPLOYEE_STATE_READY) {
        if (!window.location.href.includes("order")) {
          this.redirectToOrderIfOperatorReady();
        }
      }
    },
    checkOperatorTrainingStatus() {
      const isTraining = +window.sessionStorage.getItem("state");
      this.SET_IS_LOADING_ORDER_DATA(false);
      if (isTraining !== null && isTraining === EMPLOYEE_STATE_TRAINING) {
        this.startTraining = true;
        this.toggleKeepAlive();
      }
    },
  },
  created() {
    this.getTime();
    this.user = Vue.auth.getUser();

    if (this.$vuetify.breakpoint.xsOnly) {
      this.mini = false;
    }

    this.fetchEmployee();
  },
  mounted() {
    EventBus.$on("set-mini", (val) => (this.mini = val));
    EventBus.$on(
      "set-sidebar-user-tile-active",
      (val) => (this.activeUserTile = val)
    );

    EventBus.$on("operator-checkout-failed", (val) => {
      if (val) {
        this.onOperatorCheckoutTimeOut();
      }
    });

    EventBus.$on('change-start-job-status-false', () => {
      if (this.startJob) {
        this.onChangeStartJob();
      }
    });

    EventBus.$on("reset-start-job", () => {
      this.startJob = false;
      this.onStartJobFalse();
      this.resetOrderTimer();
    });

    EventBus.$on("operator-approved-job", (val) => {
      this.startOrderTimer = val;
    });

    EventBus.$on("set-customer-phone-number", () => {
      this.phoneActive = true;
    });

    EventBus.$on("set-sidebar-mobile-breakpoint", (val) => {
      this.mobileBreakPoint = val;
    });

    EventBus.$on("show-phone", (val) => {
      this.phoneActive = val;
      if (!val) {
        this.showPhone = true;
      }
    });

    EventBus.$on("reset-phone-draggable", () => {
      this.phoneActive = false;
      this.showPhone = true;
    });

    EventBus.$on("reset-order-timer", (val) => {
      if (val) {
        this.resetOrderTimer();
      }
    });

    EventBus.$on("logout-user", () => {
      this.logout();
    });

    if (window.location.href.includes("order")) {
      this.redirectToOrderIfOperatorReady();
    }

    EventBus.$on("show-training-modal", () => {
      this.showTrainingTopicModal = true;
    });

    EventBus.$on("phone_is_registered", (state) => {
      this.phoneIsRegistered = state;
    });

    EventBus.$on("fetch-employee", (val) => val && this.fetchEmployee());

    window.addEventListener("beforeunload", () => {
      window.sessionStorage.removeItem(STORAGE_ORDER_SCRIPS);
      window.sessionStorage.removeItem(STORAGE_ORDER_FORM);
    });
  },
  beforeDestroy() {
    EventBus.$off([
      "operator-checkout-failed",
      "set-sidebar-user-tile-active",
      "set-mini",
      "set-customer-phone-number",
      "reset-phone-draggable",
      "set-start-timer",
      "stop-online-timer",
      "logout-user",
      "reset-order-timer",
      "is-call",
    ]);
  },
  filters: {
    filterUsername(name) {
      return name.split("@")[0];
    },
  },
  watch: {
    employee: {
      handler(data) {
        const locale = data.locale || navigator.language;
        this.currentLocale = this.$store.getters.getCurrentLocale(locale);
      },
    },
    isLoading: {
      handler(value) {
        if (value && this.startJob) {
          this.checkOperatorStatus();
          this.disabledStartWork = false;
        } else if (!value && this.startJob) {
          this.disabledStartWork = true;
        }
      }
    },
    startTraining: {
      handler(value) {
        const isReady = +window.sessionStorage.getItem("state");
        if (isReady === EMPLOYEE_STATE_TRAINING) {
          return;
        }
      },
    },
    startJob: {
      handler(value) {
        const isReady = +window.sessionStorage.getItem("state");
        if (isReady === EMPLOYEE_STATE_READY) {
          return;
        }

        if (!value) {
          this.RESET_PRODUCTS_AND_SETS_FORM();
          this.RESET_ORDER_ERRORS_RULES_DATA();
          this.RESET_ORDER_ERRORS_DATA();
          this.RESET_ORDER_DATA();
          this.RESET_SCRIPTS_DATA();
          this.SET_CUSTOM_DISCOUNT_DATA({});
          this.notReadyCheckbox = false;
          this.switchToTrainingCheckbox = false;
        }
      },
    },
    time: {
      handler({ data }) {
        this.setTimeData(data);
        this.checkOperatorStatus();
        if (this.startJob) {
          this.startTimer = true;
        }

      },
    },
    refetchOrder: {
      handler(val) {
        this.startJob = val;
      },
    },
    locales: {
      handler() {
        if (this.employee) return;
        this.currentLocale = this.$store.getters.getCurrentLocale(
          navigator.language
        );
      },
    },
    order: {
      handler(data) {
        if (!data) return;
        if (data.order && this.startJob) {
          this.openReadyModal = true;
          if (this.mini) {
            this.showPhoneIcon = true;
          }
          if (!window.location.href.includes("order")) {

            this.$router.push({name: 'order.edit'})
            this.onReadyModal(true);
          }
        }
      },
    },
    notReadyCheckbox: {
      immediate: true,
      handler(val) {
        this.SET_NOT_READY(val);
      },
    },
    switchToTrainingCheckbox: {
      immediate: true,
      handler(val) {
        this.SET_TRAINING_MODE_ON(val);
      },
    },
    mini: {
      immediate: true,
      handler(val) {
        this.showPhoneIcon = val;
        this.activeUserTile = false;
        if (!val) {
          EventBus.$emit("show-phone", false);
        }
        this.SET_SIDEBAR_MINI_DATA(val);
      },
    },
    changeReadyState: {
      handler() {
        this.disabledStartWork = false;
        this.disabledStartTraining = false;

        if (this.startJob) {
          this.SET_REFETCH_ORDER_DATA(true);
          this.SET_IS_LOADING_ORDER_DATA(true);
          this.$router.push({ name: "order.edit" });
        } else if (this.startTraining) {
          // console.log('startTraining changeReadyState')
        } else {
          this.onStartJobFalse();
        }
      },
    }
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  background-color: $sidebarColor !important;
  .sidebar-nav-icon {
    img {
      width: 35px;
      height: 65px;
      vertical-align: middle;
      margin-left: 2px;
    }
  }
  .sidebar-phone-icon {
    border-radius: 50%;
    margin: 0 0 0 6px;
    img {
      width: 28px;
      height: 28px;
      vertical-align: middle;
    }
    &.opened {
      background-color: #3657b2;
    }
  }
  .openedBg {
    background-color: #23252e;
  }

  .phone-container {
    padding: 0 10px 9px 0;
    margin: 0;
  }
}

.sidebar_user_title {
  overflow: inherit;
  margin-bottom: 20px;
  margin-right: -16px;
  text-overflow: ellipsis;
  max-width: 100px;
  white-space: nowrap;
}

.logo-mini-icon {
  margin: 10px;
}

.user-menu {
  height: 32px;
  /deep/ .v-list__tile {
    height: 32px !important;
  }
  .v-list__tile__title {
    font-size: 14px;
  }
}
.user-menu-footer {
  margin-top: 39px;
  padding-bottom: 10px;
}

.sidebar_user-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

.sidebar-user-wrap {
  padding: 10px 0;
}

.nav-icon-wrapper {
  display: inline-block;
}

.sidebar-footer {
  div {
    color: rgba(255, 255, 255, 0.5);
  }
}

.v-navigation-drawer {
  display: flex !important;

  .sidebar-footer {
    position: absolute;
    bottom: 0 !important;

    /deep/ .v-list__tile {
      height: 55px !important;
    }
  }

  /deep/ .v-avatar {
    cursor: pointer;
    margin-left: -5px;
  }

  /deep/ .v-list__group--active {
    background: #23252e !important;

    &::before,
    &::after {
      background: none !important;
    }
  }

  .start-job-switcher {
    padding-left: 5px;
  }

  /deep/ .job-timer {
    text-align: center;
    margin-left: 11px;
  }

  /deep/ .begin-job-btn {
    min-height: 40px !important;
    .v-btn__content {
      font-size: 16px !important;
    }

    &--start {
      background-color: $btnSuccessColor !important;
    }

    &--end {
      background-color: #3e4047 !important;
      border: 1px solid #fff !important;
    }
  }
  /deep/ .begin-training-btn {
    min-height: 40px !important;
    .v-btn__content {
      font-size: 16px !important;
    }

    &--start {
      background-color: $btnInfoColor !important;
    }

    &--end {
      background-color: #3e4047 !important;
      border: 1px solid #fff !important;
    }
  }

  .avatar--active {
    background: rgba(23, 207, 114, 0.5) !important;
  }

  .logout {
    /deep/ .v-avatar {
      height: auto !important;
      width: auto !important;
    }

    &__icon {
      margin-right: 5px;
    }
  }

  .phone-input {
    /deep/ .v-input__append-inner {
      margin-top: -2px;
    }
    /deep/ .v-input__icon--clear {
      i {
        font-size: 18px;
      }
    }
  }

  .links-holder {
    display: flex;
    justify-content: space-between;
    a {
      font-size: 14px;
      line-height: 16px;
      color: #fff;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .to-not-ready-block {
    margin-top: 10px;

    /deep/ label {
      font-size: 14px;
    }

    /deep/ .input-group--disabled.checkbox .input-group__input {
      color: red !important;
    }
  }

  .to-training-block {
    /deep/ label {
      font-size: 14px;
    }
  }

  .timers {
    overflow: visible;
    align-items: center;
    font-size: 14px;
    margin-bottom: -30px;
  }

  .user-block {
    z-index: 2;
  }

  .icon-education {
    margin-top: 5px;
  }

  .icon-rating {
    transform: scale(1.2);
  }

  .icon-refresh {
    padding-top: 5px;
  }
}
</style>
